<template>
  <div :style="{ width: '1000px' }">
    <v-card class="d-flex pa-1 bg" outlined>
      <div class="mr-auto d-flex">
        <system-linked-combo v-model="select" :last-item="{ value: '*', text: 'Default' }"></system-linked-combo>
      </div>
    </v-card>
    <!-- eslint-disable-next-line prettier/prettier -->
    <v-data-table
      :headers="headers" :items="cloneKpiThreshold" item-key="sequence" :loading="loadings.table"
      class="elevation-1 content" dense fixed-header disable-pagination hide-default-footer height="560px"
    >
      <template v-slot:top>
        <KpiForm :formData="formItem" ref="kpiFormComp" />
      </template>
      <template v-slot:item.active="{ item }">
        <v-simple-checkbox v-model="item.active" disabled class="sp-chk-dense chk-align-c"></v-simple-checkbox>
      </template>
      <template v-slot:item.continuousAlert="{ item }">
        <v-simple-checkbox v-model="item.continuousAlert" disabled class="sp-chk-dense chk-align-c"></v-simple-checkbox>
      </template>
      <template v-slot:item.failback="{ item }">
        <v-simple-checkbox v-model="item.failback" disabled class="sp-chk-dense chk-align-c"></v-simple-checkbox>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" small color="primary" @click="editItem(item)">mdi-pencil-box-multiple-outline</v-icon>
          </template>
          <span>{{ $t('common.edit') }}</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import KpiForm from './KpiForm';

export default {
  name: 'Kpi',
  components: {
    KpiForm,
  },
  data() {
    return {
      loadings: {
        table: true,
      },
      select: { stack: 'ABAP', system: '' },
      cloneKpiThreshold: [],
      formItem: {},
    };
  },
  computed: {
    ...mapState('preference/alert', ['kpiThresholds']),
    headers() {
      return [
        { text: this.$t('alert.description'), value: 'message', width: '40%', sortable: false },
        { text: this.$t('alert.warning'), value: 'warningValue', sortable: false, align: 'center' },
        { text: this.$t('alert.critical'), value: 'criticalValue', sortable: false, align: 'center' },
        { text: this.$t('alert.count'), value: 'collectCount', sortable: false, align: 'center' },
        { text: this.$t('alert.decimalFormat'), value: 'unitSymbol', sortable: false, align: 'center' },
        { text: this.$t('alert.active'), value: 'active', sortable: false, align: 'center' },
        { text: this.$t('alert.continuousAlert'), value: 'continuousAlert', sortable: false, align: 'center' },
        { text: this.$t('alert.failback'), value: 'failback', sortable: false, align: 'center' },
        { text: '', value: 'actions', align: 'center', sortable: false },
      ];
    },
  },
  watch: {
    kpiThresholds(value) {
      this.cloneKpiThreshold = value;
      this.$nextTick(() => {
        this.loadings.table = false;
      });
    },
    select: {
      deep: true,
      handler() {
        this.fetchKpiThresholds();
      },
    },
  },
  methods: {
    fetchKpiThresholds() {
      this.loadings.table = true;
      let paramselect = {
        stackType: this.select.stack,
        id: this.select.system,
      };
      this.$store.dispatch('preference/alert/kpiThreshold', paramselect);
    },
    editItem(item) {
      this.formItem = {};
      this.formItem = item;
      if (this.formItem) this.$refs.kpiFormComp.$data.show = true;
    },
  },
};
</script>
